export default __webpack_public_path__ + "static/media/astropay-isotipo.b9088f41.svg";